import { IAppState } from '../../../store/appState';
import { Vorschaeden } from '../../../store/reducers/vorschaeden.reducer';

export const selectVorschaedenUeberschritten = (state: IAppState): boolean => {
  return state.vorschaeden.phVorschaeden > 4;
};

export const selectVorschaeden = (state: IAppState): Vorschaeden => state.vorschaeden;
